var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[(_setup.loading)?_c('Loader',{attrs:{"full-page":true}}):_vm._e(),(_setup.companyInfo)?[_c(_setup.CompanyDetailsInfoForm,{attrs:{"company":_setup.companyInfo}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }